import {Injectable} from '@angular/core';
import {ServiceModule} from "../../../service.module";

export class ZipFile {
    fileName: string;
    content: any;
    constructor(fileName: string, content: any) {
        this.fileName = fileName;
        this.content = content;
    }
}

@Injectable({providedIn: ServiceModule})
export class ZipService {
    JSZip: any;

    async loadJSZip() {
        if (!this.JSZip) {
            const jsZipModule = await import("jszip");
            this.JSZip = jsZipModule;
        }
    }

    async generateZip(content: ZipFile[], fileName: string) {
        await this.loadJSZip();
        const zip = new this.JSZip.default();
        content.forEach((item) => {
            zip.file(item.fileName, item.content);
        });

        const type = this.JSZip.default.support.uint8array ? "uint8array" : "string";
        const promise = zip.generateAsync({type: type});

        try {
            const resultBlob = await promise;
            const blob = new Blob([resultBlob], {type: 'octet/stream'});
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = window.URL.createObjectURL(blob);
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } catch (e) {
            console.error(e);
            throw e;
        }
    }
}
